import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _22139184 = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _65b5a15a = () => interopDefault(import('../pages/daftar-implementasi-pesantren/index.vue' /* webpackChunkName: "pages/daftar-implementasi-pesantren/index" */))
const _101cde46 = () => interopDefault(import('../pages/loan/index.vue' /* webpackChunkName: "pages/loan/index" */))
const _45b0b68e = () => interopDefault(import('../pages/login-history/index.vue' /* webpackChunkName: "pages/login-history/index" */))
const _422b3000 = () => interopDefault(import('../pages/ppob/index.vue' /* webpackChunkName: "pages/ppob/index" */))
const _4bb7511c = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _06c71ab2 = () => interopDefault(import('../pages/read-more.vue' /* webpackChunkName: "pages/read-more" */))
const _80ac7910 = () => interopDefault(import('../pages/santri/index.vue' /* webpackChunkName: "pages/santri/index" */))
const _60845444 = () => interopDefault(import('../pages/unauthorized.vue' /* webpackChunkName: "pages/unauthorized" */))
const _3d21d0ee = () => interopDefault(import('../pages/admin/home.vue' /* webpackChunkName: "pages/admin/home" */))
const _04c79e32 = () => interopDefault(import('../pages/admin/profile/index.vue' /* webpackChunkName: "pages/admin/profile/index" */))
const _8e1272a8 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _33eac2b0 = () => interopDefault(import('../pages/auth/register.vue' /* webpackChunkName: "pages/auth/register" */))
const _3f9f4090 = () => interopDefault(import('../pages/auth/register-santri.vue' /* webpackChunkName: "pages/auth/register-santri" */))
const _f0574092 = () => interopDefault(import('../pages/auth/verification-email.vue' /* webpackChunkName: "pages/auth/verification-email" */))
const _8842a078 = () => interopDefault(import('../pages/daftar-implementasi-pesantren/success.vue' /* webpackChunkName: "pages/daftar-implementasi-pesantren/success" */))
const _c2a2a0a0 = () => interopDefault(import('../pages/host/midtrans/index.vue' /* webpackChunkName: "pages/host/midtrans/index" */))
const _3ddb9ff0 = () => interopDefault(import('../pages/host/otto/index.vue' /* webpackChunkName: "pages/host/otto/index" */))
const _4441372b = () => interopDefault(import('../pages/host/pay.vue' /* webpackChunkName: "pages/host/pay" */))
const _cfc4daa0 = () => interopDefault(import('../pages/loan/compare.vue' /* webpackChunkName: "pages/loan/compare" */))
const _2df4d581 = () => interopDefault(import('../pages/loan/create.vue' /* webpackChunkName: "pages/loan/create" */))
const _6563493a = () => interopDefault(import('../pages/loan/list.vue' /* webpackChunkName: "pages/loan/list" */))
const _5eee6e6c = () => interopDefault(import('../pages/loan/products/index.vue' /* webpackChunkName: "pages/loan/products/index" */))
const _5d0ea0ce = () => interopDefault(import('../pages/loan/simulasi.vue' /* webpackChunkName: "pages/loan/simulasi" */))
const _20fd85b6 = () => interopDefault(import('../pages/login-history/create.vue' /* webpackChunkName: "pages/login-history/create" */))
const _509a8edf = () => interopDefault(import('../pages/page/al-quran.vue' /* webpackChunkName: "pages/page/al-quran" */))
const _6138418b = () => interopDefault(import('../pages/page/cek-status-booking/index.vue' /* webpackChunkName: "pages/page/cek-status-booking/index" */))
const _8be2c97a = () => interopDefault(import('../pages/page/hadits.vue' /* webpackChunkName: "pages/page/hadits" */))
const _768c94f5 = () => interopDefault(import('../pages/page/jadwal-shalat.vue' /* webpackChunkName: "pages/page/jadwal-shalat" */))
const _d6162e96 = () => interopDefault(import('../pages/page/kontak-kami.vue' /* webpackChunkName: "pages/page/kontak-kami" */))
const _190234d2 = () => interopDefault(import('../pages/page/peta-situs.vue' /* webpackChunkName: "pages/page/peta-situs" */))
const _48ed85c6 = () => interopDefault(import('../pages/page/privacy-policy.vue' /* webpackChunkName: "pages/page/privacy-policy" */))
const _6441f661 = () => interopDefault(import('../pages/page/surat-pendek.vue' /* webpackChunkName: "pages/page/surat-pendek" */))
const _41e8bd82 = () => interopDefault(import('../pages/page/tentang-kami.vue' /* webpackChunkName: "pages/page/tentang-kami" */))
const _70d07708 = () => interopDefault(import('../pages/ppob/type.vue' /* webpackChunkName: "pages/ppob/type" */))
const _ec4155cc = () => interopDefault(import('../pages/santri/absensi/index.vue' /* webpackChunkName: "pages/santri/absensi/index" */))
const _6c3418f4 = () => interopDefault(import('../pages/santri/profil.vue' /* webpackChunkName: "pages/santri/profil" */))
const _0c2ff858 = () => interopDefault(import('../pages/admin/akademik/kenaikan-kelas/index.vue' /* webpackChunkName: "pages/admin/akademik/kenaikan-kelas/index" */))
const _73732c13 = () => interopDefault(import('../pages/admin/core/akun-keuangan/index.vue' /* webpackChunkName: "pages/admin/core/akun-keuangan/index" */))
const _124b90ea = () => interopDefault(import('../pages/admin/core/buku-besar/index.vue' /* webpackChunkName: "pages/admin/core/buku-besar/index" */))
const _d900c45e = () => interopDefault(import('../pages/admin/core/jurnal-khusus/index.vue' /* webpackChunkName: "pages/admin/core/jurnal-khusus/index" */))
const _514512ba = () => interopDefault(import('../pages/admin/core/jurnal-penyesuaian/index.vue' /* webpackChunkName: "pages/admin/core/jurnal-penyesuaian/index" */))
const _04cfda30 = () => interopDefault(import('../pages/admin/core/jurnal-umum/index.vue' /* webpackChunkName: "pages/admin/core/jurnal-umum/index" */))
const _cdfb8fee = () => interopDefault(import('../pages/admin/core/kertas-kerja/index.vue' /* webpackChunkName: "pages/admin/core/kertas-kerja/index" */))
const _f4fe7a4a = () => interopDefault(import('../pages/admin/core/laba-rugi/index.vue' /* webpackChunkName: "pages/admin/core/laba-rugi/index" */))
const _38ad3e67 = () => interopDefault(import('../pages/admin/core/laporan-keuangan/index.vue' /* webpackChunkName: "pages/admin/core/laporan-keuangan/index" */))
const _4906e13d = () => interopDefault(import('../pages/admin/core/neraca/index.vue' /* webpackChunkName: "pages/admin/core/neraca/index" */))
const _57c75931 = () => interopDefault(import('../pages/admin/customer-service/blast-wa/index.vue' /* webpackChunkName: "pages/admin/customer-service/blast-wa/index" */))
const _fb1ab4b2 = () => interopDefault(import('../pages/admin/customer-service/candidate/index.vue' /* webpackChunkName: "pages/admin/customer-service/candidate/index" */))
const _32f4d14c = () => interopDefault(import('../pages/admin/customer-service/nasabah/index.vue' /* webpackChunkName: "pages/admin/customer-service/nasabah/index" */))
const _3f9a77a5 = () => interopDefault(import('../pages/admin/customer-service/nominatif/index.vue' /* webpackChunkName: "pages/admin/customer-service/nominatif/index" */))
const _28becaed = () => interopDefault(import('../pages/admin/customer-service/registrasi/index.vue' /* webpackChunkName: "pages/admin/customer-service/registrasi/index" */))
const _5d7be1a1 = () => interopDefault(import('../pages/admin/customer-service/rekening-koran/index.vue' /* webpackChunkName: "pages/admin/customer-service/rekening-koran/index" */))
const _43c2cbb8 = () => interopDefault(import('../pages/admin/customer-service/rekening-vendor/index.vue' /* webpackChunkName: "pages/admin/customer-service/rekening-vendor/index" */))
const _045c9292 = () => interopDefault(import('../pages/admin/customer-service/rekening-wali/index.vue' /* webpackChunkName: "pages/admin/customer-service/rekening-wali/index" */))
const _66043c42 = () => interopDefault(import('../pages/admin/customer-service/riwayat-transfer/index.vue' /* webpackChunkName: "pages/admin/customer-service/riwayat-transfer/index" */))
const _0403aeca = () => interopDefault(import('../pages/admin/customer-service/tagihan/index.vue' /* webpackChunkName: "pages/admin/customer-service/tagihan/index" */))
const _6f892a30 = () => interopDefault(import('../pages/admin/customer-service/tagihan-spp/index.vue' /* webpackChunkName: "pages/admin/customer-service/tagihan-spp/index" */))
const _697dbc8c = () => interopDefault(import('../pages/admin/customer-service/transaksi/index.vue' /* webpackChunkName: "pages/admin/customer-service/transaksi/index" */))
const _9a47bc8e = () => interopDefault(import('../pages/admin/customer-service/wali/index.vue' /* webpackChunkName: "pages/admin/customer-service/wali/index" */))
const _21034dfd = () => interopDefault(import('../pages/admin/lms/absensi/index.vue' /* webpackChunkName: "pages/admin/lms/absensi/index" */))
const _4c5dbb5c = () => interopDefault(import('../pages/admin/lms/mata-pelajaran/index.vue' /* webpackChunkName: "pages/admin/lms/mata-pelajaran/index" */))
const _7c25ee05 = () => interopDefault(import('../pages/admin/lms/nilai/index.vue' /* webpackChunkName: "pages/admin/lms/nilai/index" */))
const _38512df7 = () => interopDefault(import('../pages/admin/lms/pengajuan/index.vue' /* webpackChunkName: "pages/admin/lms/pengajuan/index" */))
const _38fa343a = () => interopDefault(import('../pages/admin/lms/raport/index.vue' /* webpackChunkName: "pages/admin/lms/raport/index" */))
const _0be5bf52 = () => interopDefault(import('../pages/admin/master/bank/index.vue' /* webpackChunkName: "pages/admin/master/bank/index" */))
const _f92d915c = () => interopDefault(import('../pages/admin/master/bcn-bank/index.vue' /* webpackChunkName: "pages/admin/master/bcn-bank/index" */))
const _2a994a7d = () => interopDefault(import('../pages/admin/master/bcn-bank-institution/index.vue' /* webpackChunkName: "pages/admin/master/bcn-bank-institution/index" */))
const _54fb562c = () => interopDefault(import('../pages/admin/master/document-type/index.vue' /* webpackChunkName: "pages/admin/master/document-type/index" */))
const _6ebd6466 = () => interopDefault(import('../pages/admin/master/jenis-kas/index.vue' /* webpackChunkName: "pages/admin/master/jenis-kas/index" */))
const _60e0f418 = () => interopDefault(import('../pages/admin/master/jenis-pinjaman/index.vue' /* webpackChunkName: "pages/admin/master/jenis-pinjaman/index" */))
const _7fee6a32 = () => interopDefault(import('../pages/admin/master/jenis-rekening/index.vue' /* webpackChunkName: "pages/admin/master/jenis-rekening/index" */))
const _455ad279 = () => interopDefault(import('../pages/admin/master/jenis-simpanan/index.vue' /* webpackChunkName: "pages/admin/master/jenis-simpanan/index" */))
const _ba64c316 = () => interopDefault(import('../pages/admin/master/jenjang-pendidikan/index.vue' /* webpackChunkName: "pages/admin/master/jenjang-pendidikan/index" */))
const _cf012526 = () => interopDefault(import('../pages/admin/master/lembaga/index.vue' /* webpackChunkName: "pages/admin/master/lembaga/index" */))
const _1146300e = () => interopDefault(import('../pages/admin/master/lembaga-booking/index.vue' /* webpackChunkName: "pages/admin/master/lembaga-booking/index" */))
const _48bbb329 = () => interopDefault(import('../pages/admin/master/news/index.vue' /* webpackChunkName: "pages/admin/master/news/index" */))
const _ac37dd90 = () => interopDefault(import('../pages/admin/master/news-category/index.vue' /* webpackChunkName: "pages/admin/master/news-category/index" */))
const _41aca543 = () => interopDefault(import('../pages/admin/master/produk/index.vue' /* webpackChunkName: "pages/admin/master/produk/index" */))
const _3d051d68 = () => interopDefault(import('../pages/admin/master/produk-vendor/index.vue' /* webpackChunkName: "pages/admin/master/produk-vendor/index" */))
const _9f74b68a = () => interopDefault(import('../pages/admin/master/setting-institution/index.vue' /* webpackChunkName: "pages/admin/master/setting-institution/index" */))
const _5a268556 = () => interopDefault(import('../pages/admin/master/tahun-ajaran/index.vue' /* webpackChunkName: "pages/admin/master/tahun-ajaran/index" */))
const _4374051f = () => interopDefault(import('../pages/admin/master/transaction-type/index.vue' /* webpackChunkName: "pages/admin/master/transaction-type/index" */))
const _05a6a6c4 = () => interopDefault(import('../pages/admin/master/vendor/index.vue' /* webpackChunkName: "pages/admin/master/vendor/index" */))
const _c74e1c94 = () => interopDefault(import('../pages/admin/pengaturan/activity-logs/index.vue' /* webpackChunkName: "pages/admin/pengaturan/activity-logs/index" */))
const _190b7d9e = () => interopDefault(import('../pages/admin/pengaturan/management-user/index.vue' /* webpackChunkName: "pages/admin/pengaturan/management-user/index" */))
const _2a638ea6 = () => interopDefault(import('../pages/admin/pengaturan/management-user-vendor/index.vue' /* webpackChunkName: "pages/admin/pengaturan/management-user-vendor/index" */))
const _e3458888 = () => interopDefault(import('../pages/admin/pengaturan/permission/index.vue' /* webpackChunkName: "pages/admin/pengaturan/permission/index" */))
const _ed05b1ba = () => interopDefault(import('../pages/admin/pengaturan/role/index.vue' /* webpackChunkName: "pages/admin/pengaturan/role/index" */))
const _d24770bc = () => interopDefault(import('../pages/admin/pengaturan/role-has-permission/index.vue' /* webpackChunkName: "pages/admin/pengaturan/role-has-permission/index" */))
const _7f60e434 = () => interopDefault(import('../pages/admin/pengaturan/seo/index.vue' /* webpackChunkName: "pages/admin/pengaturan/seo/index" */))
const _00f0285b = () => interopDefault(import('../pages/admin/pengaturan/setting-data-fixed/index.vue' /* webpackChunkName: "pages/admin/pengaturan/setting-data-fixed/index" */))
const _5f6004b4 = () => interopDefault(import('../pages/admin/pengaturan/setting-web-app/index.vue' /* webpackChunkName: "pages/admin/pengaturan/setting-web-app/index" */))
const _2cc69878 = () => interopDefault(import('../pages/admin/profile/change-password.vue' /* webpackChunkName: "pages/admin/profile/change-password" */))
const _b10a2d10 = () => interopDefault(import('../pages/admin/rekonsiliasi/invoice/index.vue' /* webpackChunkName: "pages/admin/rekonsiliasi/invoice/index" */))
const _289fc333 = () => interopDefault(import('../pages/admin/rekonsiliasi/transaksi/index.vue' /* webpackChunkName: "pages/admin/rekonsiliasi/transaksi/index" */))
const _68f9447e = () => interopDefault(import('../pages/admin/transaksi/monitoring-admin/index.vue' /* webpackChunkName: "pages/admin/transaksi/monitoring-admin/index" */))
const _c30a3b76 = () => interopDefault(import('../pages/admin/transaksi/open-api-payments/index.vue' /* webpackChunkName: "pages/admin/transaksi/open-api-payments/index" */))
const _79aff07b = () => interopDefault(import('../pages/admin/transaksi/penarikan/index.vue' /* webpackChunkName: "pages/admin/transaksi/penarikan/index" */))
const _40202648 = () => interopDefault(import('../pages/admin/transaksi/penarikan-otomatis/index.vue' /* webpackChunkName: "pages/admin/transaksi/penarikan-otomatis/index" */))
const _110966fc = () => interopDefault(import('../pages/admin/transaksi/setoran-tunai/index.vue' /* webpackChunkName: "pages/admin/transaksi/setoran-tunai/index" */))
const _ca0da926 = () => interopDefault(import('../pages/host/flip/accept.vue' /* webpackChunkName: "pages/host/flip/accept" */))
const _0b554590 = () => interopDefault(import('../pages/host/flip/transfer.vue' /* webpackChunkName: "pages/host/flip/transfer" */))
const _f04f7398 = () => interopDefault(import('../pages/admin/akademik/kenaikan-kelas/histories.vue' /* webpackChunkName: "pages/admin/akademik/kenaikan-kelas/histories" */))
const _22a6a10b = () => interopDefault(import('../pages/admin/core/akun-keuangan/create.vue' /* webpackChunkName: "pages/admin/core/akun-keuangan/create" */))
const _45c2d654 = () => interopDefault(import('../pages/admin/core/jurnal-umum/create.vue' /* webpackChunkName: "pages/admin/core/jurnal-umum/create" */))
const _01ab5c2e = () => interopDefault(import('../pages/admin/customer-service/blast-wa/template/index.vue' /* webpackChunkName: "pages/admin/customer-service/blast-wa/template/index" */))
const _18d34c12 = () => interopDefault(import('../pages/admin/customer-service/candidate/create.vue' /* webpackChunkName: "pages/admin/customer-service/candidate/create" */))
const _a31c9ea2 = () => interopDefault(import('../pages/admin/customer-service/candidate/export.vue' /* webpackChunkName: "pages/admin/customer-service/candidate/export" */))
const _126953c8 = () => interopDefault(import('../pages/admin/customer-service/candidate/qr.vue' /* webpackChunkName: "pages/admin/customer-service/candidate/qr" */))
const _198df03f = () => interopDefault(import('../pages/admin/customer-service/candidate/rekening/index.vue' /* webpackChunkName: "pages/admin/customer-service/candidate/rekening/index" */))
const _d9068708 = () => interopDefault(import('../pages/admin/customer-service/candidate/upload.vue' /* webpackChunkName: "pages/admin/customer-service/candidate/upload" */))
const _5359a2f2 = () => interopDefault(import('../pages/admin/customer-service/nasabah/create.vue' /* webpackChunkName: "pages/admin/customer-service/nasabah/create" */))
const _0e34f9aa = () => interopDefault(import('../pages/admin/customer-service/nasabah/export.vue' /* webpackChunkName: "pages/admin/customer-service/nasabah/export" */))
const _0a785497 = () => interopDefault(import('../pages/admin/customer-service/nasabah/qr.vue' /* webpackChunkName: "pages/admin/customer-service/nasabah/qr" */))
const _b6bbe38c = () => interopDefault(import('../pages/admin/customer-service/nasabah/rekening/index.vue' /* webpackChunkName: "pages/admin/customer-service/nasabah/rekening/index" */))
const _197ff512 = () => interopDefault(import('../pages/admin/customer-service/nasabah/upload.vue' /* webpackChunkName: "pages/admin/customer-service/nasabah/upload" */))
const _16cedd71 = () => interopDefault(import('../pages/admin/customer-service/registrasi/create.vue' /* webpackChunkName: "pages/admin/customer-service/registrasi/create" */))
const _2d7bb412 = () => interopDefault(import('../pages/admin/customer-service/tagihan-spp/unpaid.vue' /* webpackChunkName: "pages/admin/customer-service/tagihan-spp/unpaid" */))
const _5d926946 = () => interopDefault(import('../pages/admin/customer-service/tagihan/import.vue' /* webpackChunkName: "pages/admin/customer-service/tagihan/import" */))
const _37cf96c6 = () => interopDefault(import('../pages/admin/customer-service/tagihan/unpaid.vue' /* webpackChunkName: "pages/admin/customer-service/tagihan/unpaid" */))
const _5f473fb6 = () => interopDefault(import('../pages/admin/customer-service/wali/create.vue' /* webpackChunkName: "pages/admin/customer-service/wali/create" */))
const _0f39e86d = () => interopDefault(import('../pages/admin/customer-service/wali/rekening/index.vue' /* webpackChunkName: "pages/admin/customer-service/wali/rekening/index" */))
const _271abc61 = () => interopDefault(import('../pages/admin/lms/absensi/create.vue' /* webpackChunkName: "pages/admin/lms/absensi/create" */))
const _22619d0e = () => interopDefault(import('../pages/admin/lms/absensi/riwayat/index.vue' /* webpackChunkName: "pages/admin/lms/absensi/riwayat/index" */))
const _670dfae2 = () => interopDefault(import('../pages/admin/lms/mata-pelajaran/create.vue' /* webpackChunkName: "pages/admin/lms/mata-pelajaran/create" */))
const _304c1d59 = () => interopDefault(import('../pages/admin/lms/nilai/create.vue' /* webpackChunkName: "pages/admin/lms/nilai/create" */))
const _5ebb111a = () => interopDefault(import('../pages/admin/lms/pengajuan/riwayat/index.vue' /* webpackChunkName: "pages/admin/lms/pengajuan/riwayat/index" */))
const _0e009dc4 = () => interopDefault(import('../pages/admin/lms/raport/create.vue' /* webpackChunkName: "pages/admin/lms/raport/create" */))
const _cef314a8 = () => interopDefault(import('../pages/admin/master/bank/create.vue' /* webpackChunkName: "pages/admin/master/bank/create" */))
const _50444fe1 = () => interopDefault(import('../pages/admin/master/bcn-bank-institution/create.vue' /* webpackChunkName: "pages/admin/master/bcn-bank-institution/create" */))
const _1171fdac = () => interopDefault(import('../pages/admin/master/bcn-bank/create.vue' /* webpackChunkName: "pages/admin/master/bcn-bank/create" */))
const _7223ba12 = () => interopDefault(import('../pages/admin/master/document-type/create.vue' /* webpackChunkName: "pages/admin/master/document-type/create" */))
const _733cb691 = () => interopDefault(import('../pages/admin/master/jenis-kas/create.vue' /* webpackChunkName: "pages/admin/master/jenis-kas/create" */))
const _4a15834a = () => interopDefault(import('../pages/admin/master/jenis-pinjaman/create.vue' /* webpackChunkName: "pages/admin/master/jenis-pinjaman/create" */))
const _68c4dcb7 = () => interopDefault(import('../pages/admin/master/jenis-rekening/create.vue' /* webpackChunkName: "pages/admin/master/jenis-rekening/create" */))
const _e4987136 = () => interopDefault(import('../pages/admin/master/jenis-simpanan/create.vue' /* webpackChunkName: "pages/admin/master/jenis-simpanan/create" */))
const _42cb0a2e = () => interopDefault(import('../pages/admin/master/jenjang-pendidikan/create.vue' /* webpackChunkName: "pages/admin/master/jenjang-pendidikan/create" */))
const _d258b2b6 = () => interopDefault(import('../pages/admin/master/lembaga/bcn-code/index.vue' /* webpackChunkName: "pages/admin/master/lembaga/bcn-code/index" */))
const _c1baea1e = () => interopDefault(import('../pages/admin/master/lembaga/create.vue' /* webpackChunkName: "pages/admin/master/lembaga/create" */))
const _315f411b = () => interopDefault(import('../pages/admin/master/lembaga/scan-qr-wa.vue' /* webpackChunkName: "pages/admin/master/lembaga/scan-qr-wa" */))
const _8b5b3ef4 = () => interopDefault(import('../pages/admin/master/news-category/create.vue' /* webpackChunkName: "pages/admin/master/news-category/create" */))
const _13220696 = () => interopDefault(import('../pages/admin/master/news/create.vue' /* webpackChunkName: "pages/admin/master/news/create" */))
const _e95a4b54 = () => interopDefault(import('../pages/admin/master/produk-vendor/create.vue' /* webpackChunkName: "pages/admin/master/produk-vendor/create" */))
const _1b9c4ddb = () => interopDefault(import('../pages/admin/master/produk/create.vue' /* webpackChunkName: "pages/admin/master/produk/create" */))
const _125e7028 = () => interopDefault(import('../pages/admin/master/tahun-ajaran/create.vue' /* webpackChunkName: "pages/admin/master/tahun-ajaran/create" */))
const _52c0e97f = () => interopDefault(import('../pages/admin/master/transaction-type/create.vue' /* webpackChunkName: "pages/admin/master/transaction-type/create" */))
const _5fc59c40 = () => interopDefault(import('../pages/admin/master/vendor/create.vue' /* webpackChunkName: "pages/admin/master/vendor/create" */))
const _d2a5b09e = () => interopDefault(import('../pages/admin/pengaturan/management-user-vendor/create.vue' /* webpackChunkName: "pages/admin/pengaturan/management-user-vendor/create" */))
const _301880e0 = () => interopDefault(import('../pages/admin/pengaturan/management-user/create.vue' /* webpackChunkName: "pages/admin/pengaturan/management-user/create" */))
const _64fe8682 = () => interopDefault(import('../pages/admin/pengaturan/permission/create.vue' /* webpackChunkName: "pages/admin/pengaturan/permission/create" */))
const _ce42a1c0 = () => interopDefault(import('../pages/admin/pengaturan/ppob/product/index.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product/index" */))
const _596cacb4 = () => interopDefault(import('../pages/admin/pengaturan/ppob/product-detail/index.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product-detail/index" */))
const _7c8a565d = () => interopDefault(import('../pages/admin/pengaturan/ppob/product-type/index.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product-type/index" */))
const _6447f00a = () => interopDefault(import('../pages/admin/pengaturan/role/create.vue' /* webpackChunkName: "pages/admin/pengaturan/role/create" */))
const _71567998 = () => interopDefault(import('../pages/admin/pengaturan/seo/create.vue' /* webpackChunkName: "pages/admin/pengaturan/seo/create" */))
const _44c92dc3 = () => interopDefault(import('../pages/admin/pengaturan/setting-data-fixed/create.vue' /* webpackChunkName: "pages/admin/pengaturan/setting-data-fixed/create" */))
const _975646ec = () => interopDefault(import('../pages/admin/pengaturan/setting-web-app/create.vue' /* webpackChunkName: "pages/admin/pengaturan/setting-web-app/create" */))
const _28ce2514 = () => interopDefault(import('../pages/admin/transaksi/penarikan-otomatis/create.vue' /* webpackChunkName: "pages/admin/transaksi/penarikan-otomatis/create" */))
const _37fb2cba = () => interopDefault(import('../pages/admin/transaksi/penarikan/create.vue' /* webpackChunkName: "pages/admin/transaksi/penarikan/create" */))
const _37d7c342 = () => interopDefault(import('../pages/admin/transaksi/setoran-tunai/create.vue' /* webpackChunkName: "pages/admin/transaksi/setoran-tunai/create" */))
const _5b747450 = () => interopDefault(import('../pages/admin/customer-service/blast-wa/template/create.vue' /* webpackChunkName: "pages/admin/customer-service/blast-wa/template/create" */))
const _084596ec = () => interopDefault(import('../pages/admin/pengaturan/ppob/product-detail/create.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product-detail/create" */))
const _3c74c001 = () => interopDefault(import('../pages/admin/pengaturan/ppob/product-type/create.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product-type/create" */))
const _aaa900c4 = () => interopDefault(import('../pages/admin/pengaturan/ppob/product/create.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product/create" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1f1e9216 = () => interopDefault(import('../pages/admin/customer-service/blast-wa/template/_id.vue' /* webpackChunkName: "pages/admin/customer-service/blast-wa/template/_id" */))
const _29815eec = () => interopDefault(import('../pages/admin/master/produk/custom-nominal/_id.vue' /* webpackChunkName: "pages/admin/master/produk/custom-nominal/_id" */))
const _c2b7d3da = () => interopDefault(import('../pages/admin/master/vendor/rekening/_id/index.vue' /* webpackChunkName: "pages/admin/master/vendor/rekening/_id/index" */))
const _5bffbe5a = () => interopDefault(import('../pages/admin/master/vendor/user/_id.vue' /* webpackChunkName: "pages/admin/master/vendor/user/_id" */))
const _09e64c1c = () => interopDefault(import('../pages/admin/pengaturan/ppob/product-detail/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product-detail/_id" */))
const _5c844c05 = () => interopDefault(import('../pages/admin/pengaturan/ppob/product-type/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product-type/_id" */))
const _548df988 = () => interopDefault(import('../pages/admin/pengaturan/ppob/product/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/ppob/product/_id" */))
const _28226c81 = () => interopDefault(import('../pages/admin/master/produk/custom-nominal/_product_id/create.vue' /* webpackChunkName: "pages/admin/master/produk/custom-nominal/_product_id/create" */))
const _004d4f90 = () => interopDefault(import('../pages/admin/master/vendor/user/_vendor_id/create.vue' /* webpackChunkName: "pages/admin/master/vendor/user/_vendor_id/create" */))
const _73f3173b = () => interopDefault(import('../pages/admin/core/akun-keuangan/_id.vue' /* webpackChunkName: "pages/admin/core/akun-keuangan/_id" */))
const _1debe5cf = () => interopDefault(import('../pages/admin/customer-service/candidate/_id.vue' /* webpackChunkName: "pages/admin/customer-service/candidate/_id" */))
const _7fdeb6b4 = () => interopDefault(import('../pages/admin/customer-service/nasabah/_id.vue' /* webpackChunkName: "pages/admin/customer-service/nasabah/_id" */))
const _70493e61 = () => interopDefault(import('../pages/admin/customer-service/wali/_id.vue' /* webpackChunkName: "pages/admin/customer-service/wali/_id" */))
const _c7d2a8b6 = () => interopDefault(import('../pages/admin/lms/absensi/_id.vue' /* webpackChunkName: "pages/admin/lms/absensi/_id" */))
const _d0ca3678 = () => interopDefault(import('../pages/admin/lms/mata-pelajaran/_id.vue' /* webpackChunkName: "pages/admin/lms/mata-pelajaran/_id" */))
const _01f1adad = () => interopDefault(import('../pages/admin/lms/nilai/_id.vue' /* webpackChunkName: "pages/admin/lms/nilai/_id" */))
const _bfc805bc = () => interopDefault(import('../pages/admin/lms/raport/_id.vue' /* webpackChunkName: "pages/admin/lms/raport/_id" */))
const _33c1238c = () => interopDefault(import('../pages/admin/master/bank/_id.vue' /* webpackChunkName: "pages/admin/master/bank/_id" */))
const _17fc6fb6 = () => interopDefault(import('../pages/admin/master/bcn-bank-institution/_id.vue' /* webpackChunkName: "pages/admin/master/bcn-bank-institution/_id" */))
const _4fbe338c = () => interopDefault(import('../pages/admin/master/bcn-bank/_id.vue' /* webpackChunkName: "pages/admin/master/bcn-bank/_id" */))
const _fcfe18d8 = () => interopDefault(import('../pages/admin/master/document-type/_id.vue' /* webpackChunkName: "pages/admin/master/document-type/_id" */))
const _43d25f75 = () => interopDefault(import('../pages/admin/master/jenis-kas/_id.vue' /* webpackChunkName: "pages/admin/master/jenis-kas/_id" */))
const _416e755c = () => interopDefault(import('../pages/admin/master/jenis-pinjaman/_id.vue' /* webpackChunkName: "pages/admin/master/jenis-pinjaman/_id" */))
const _8d6b49e2 = () => interopDefault(import('../pages/admin/master/jenis-rekening/_id.vue' /* webpackChunkName: "pages/admin/master/jenis-rekening/_id" */))
const _303d1f21 = () => interopDefault(import('../pages/admin/master/jenis-simpanan/_id.vue' /* webpackChunkName: "pages/admin/master/jenis-simpanan/_id" */))
const _72aaba1d = () => interopDefault(import('../pages/admin/master/jenjang-pendidikan/_id.vue' /* webpackChunkName: "pages/admin/master/jenjang-pendidikan/_id" */))
const _15f3e715 = () => interopDefault(import('../pages/admin/master/lembaga/_id.vue' /* webpackChunkName: "pages/admin/master/lembaga/_id" */))
const _733501a0 = () => interopDefault(import('../pages/admin/master/news-category/_id.vue' /* webpackChunkName: "pages/admin/master/news-category/_id" */))
const _6283285e = () => interopDefault(import('../pages/admin/master/news/_id.vue' /* webpackChunkName: "pages/admin/master/news/_id" */))
const _fae94c60 = () => interopDefault(import('../pages/admin/master/produk-vendor/_id.vue' /* webpackChunkName: "pages/admin/master/produk-vendor/_id" */))
const _d8cdc72a = () => interopDefault(import('../pages/admin/master/produk/_id.vue' /* webpackChunkName: "pages/admin/master/produk/_id" */))
const _48db99e3 = () => interopDefault(import('../pages/admin/master/setting-institution/_id.vue' /* webpackChunkName: "pages/admin/master/setting-institution/_id" */))
const _6b21e53e = () => interopDefault(import('../pages/admin/master/tahun-ajaran/_id.vue' /* webpackChunkName: "pages/admin/master/tahun-ajaran/_id" */))
const _642ec347 = () => interopDefault(import('../pages/admin/master/transaction-type/_id.vue' /* webpackChunkName: "pages/admin/master/transaction-type/_id" */))
const _0e993e86 = () => interopDefault(import('../pages/admin/master/vendor/_id.vue' /* webpackChunkName: "pages/admin/master/vendor/_id" */))
const _64782cc4 = () => interopDefault(import('../pages/admin/pengaturan/activity-logs/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/activity-logs/_id" */))
const _7006fb56 = () => interopDefault(import('../pages/admin/pengaturan/management-user-vendor/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/management-user-vendor/_id" */))
const _f40f60f4 = () => interopDefault(import('../pages/admin/pengaturan/management-user/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/management-user/_id" */))
const _1b8205b8 = () => interopDefault(import('../pages/admin/pengaturan/permission/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/permission/_id" */))
const _26bbca8a = () => interopDefault(import('../pages/admin/pengaturan/role-has-permission/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/role-has-permission/_id" */))
const _a13ed36a = () => interopDefault(import('../pages/admin/pengaturan/role/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/role/_id" */))
const _73d85c64 = () => interopDefault(import('../pages/admin/pengaturan/seo/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/seo/_id" */))
const _6b928583 = () => interopDefault(import('../pages/admin/pengaturan/setting-data-fixed/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/setting-data-fixed/_id" */))
const _24cfa41c = () => interopDefault(import('../pages/admin/pengaturan/setting-web-app/_id.vue' /* webpackChunkName: "pages/admin/pengaturan/setting-web-app/_id" */))
const _df21aa9a = () => interopDefault(import('../pages/page/cek-status-booking/_id.vue' /* webpackChunkName: "pages/page/cek-status-booking/_id" */))
const _93637a92 = () => interopDefault(import('../pages/auth/_registerBak.vue' /* webpackChunkName: "pages/auth/_registerBak" */))
const _07acf548 = () => interopDefault(import('../pages/loan/_id/index.vue' /* webpackChunkName: "pages/loan/_id/index" */))
const _a4ccfd3e = () => interopDefault(import('../pages/login-history/_id.vue' /* webpackChunkName: "pages/login-history/_id" */))
const _f5b3a5bc = () => interopDefault(import('../pages/pay/_session_id.vue' /* webpackChunkName: "pages/pay/_session_id" */))
const _1c5a7cc4 = () => interopDefault(import('../pages/loan/_id/pay.vue' /* webpackChunkName: "pages/loan/_id/pay" */))
const _2efaf336 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _22139184,
    name: "404"
  }, {
    path: "/daftar-implementasi-pesantren",
    component: _65b5a15a,
    name: "daftar-implementasi-pesantren"
  }, {
    path: "/loan",
    component: _101cde46,
    name: "loan"
  }, {
    path: "/login-history",
    component: _45b0b68e,
    name: "login-history"
  }, {
    path: "/ppob",
    component: _422b3000,
    name: "ppob"
  }, {
    path: "/profile",
    component: _4bb7511c,
    name: "profile"
  }, {
    path: "/read-more",
    component: _06c71ab2,
    name: "read-more"
  }, {
    path: "/santri",
    component: _80ac7910,
    name: "santri"
  }, {
    path: "/unauthorized",
    component: _60845444,
    name: "unauthorized"
  }, {
    path: "/admin/home",
    component: _3d21d0ee,
    name: "admin-home"
  }, {
    path: "/admin/profile",
    component: _04c79e32,
    name: "admin-profile"
  }, {
    path: "/auth/login",
    component: _8e1272a8,
    name: "auth-login"
  }, {
    path: "/auth/register",
    component: _33eac2b0,
    name: "auth-register"
  }, {
    path: "/auth/register-santri",
    component: _3f9f4090,
    name: "auth-register-santri"
  }, {
    path: "/auth/verification-email",
    component: _f0574092,
    name: "auth-verification-email"
  }, {
    path: "/daftar-implementasi-pesantren/success",
    component: _8842a078,
    name: "daftar-implementasi-pesantren-success"
  }, {
    path: "/host/midtrans",
    component: _c2a2a0a0,
    name: "host-midtrans"
  }, {
    path: "/host/otto",
    component: _3ddb9ff0,
    name: "host-otto"
  }, {
    path: "/host/pay",
    component: _4441372b,
    name: "host-pay"
  }, {
    path: "/loan/compare",
    component: _cfc4daa0,
    name: "loan-compare"
  }, {
    path: "/loan/create",
    component: _2df4d581,
    name: "loan-create"
  }, {
    path: "/loan/list",
    component: _6563493a,
    name: "loan-list"
  }, {
    path: "/loan/products",
    component: _5eee6e6c,
    name: "loan-products"
  }, {
    path: "/loan/simulasi",
    component: _5d0ea0ce,
    name: "loan-simulasi"
  }, {
    path: "/login-history/create",
    component: _20fd85b6,
    name: "login-history-create"
  }, {
    path: "/page/al-quran",
    component: _509a8edf,
    name: "page-al-quran"
  }, {
    path: "/page/cek-status-booking",
    component: _6138418b,
    name: "page-cek-status-booking"
  }, {
    path: "/page/hadits",
    component: _8be2c97a,
    name: "page-hadits"
  }, {
    path: "/page/jadwal-shalat",
    component: _768c94f5,
    name: "page-jadwal-shalat"
  }, {
    path: "/page/kontak-kami",
    component: _d6162e96,
    name: "page-kontak-kami"
  }, {
    path: "/page/peta-situs",
    component: _190234d2,
    name: "page-peta-situs"
  }, {
    path: "/page/privacy-policy",
    component: _48ed85c6,
    name: "page-privacy-policy"
  }, {
    path: "/page/surat-pendek",
    component: _6441f661,
    name: "page-surat-pendek"
  }, {
    path: "/page/tentang-kami",
    component: _41e8bd82,
    name: "page-tentang-kami"
  }, {
    path: "/ppob/type",
    component: _70d07708,
    name: "ppob-type"
  }, {
    path: "/santri/absensi",
    component: _ec4155cc,
    name: "santri-absensi"
  }, {
    path: "/santri/profil",
    component: _6c3418f4,
    name: "santri-profil"
  }, {
    path: "/admin/akademik/kenaikan-kelas",
    component: _0c2ff858,
    name: "admin-akademik-kenaikan-kelas"
  }, {
    path: "/admin/core/akun-keuangan",
    component: _73732c13,
    name: "admin-core-akun-keuangan"
  }, {
    path: "/admin/core/buku-besar",
    component: _124b90ea,
    name: "admin-core-buku-besar"
  }, {
    path: "/admin/core/jurnal-khusus",
    component: _d900c45e,
    name: "admin-core-jurnal-khusus"
  }, {
    path: "/admin/core/jurnal-penyesuaian",
    component: _514512ba,
    name: "admin-core-jurnal-penyesuaian"
  }, {
    path: "/admin/core/jurnal-umum",
    component: _04cfda30,
    name: "admin-core-jurnal-umum"
  }, {
    path: "/admin/core/kertas-kerja",
    component: _cdfb8fee,
    name: "admin-core-kertas-kerja"
  }, {
    path: "/admin/core/laba-rugi",
    component: _f4fe7a4a,
    name: "admin-core-laba-rugi"
  }, {
    path: "/admin/core/laporan-keuangan",
    component: _38ad3e67,
    name: "admin-core-laporan-keuangan"
  }, {
    path: "/admin/core/neraca",
    component: _4906e13d,
    name: "admin-core-neraca"
  }, {
    path: "/admin/customer-service/blast-wa",
    component: _57c75931,
    name: "admin-customer-service-blast-wa"
  }, {
    path: "/admin/customer-service/candidate",
    component: _fb1ab4b2,
    name: "admin-customer-service-candidate"
  }, {
    path: "/admin/customer-service/nasabah",
    component: _32f4d14c,
    name: "admin-customer-service-nasabah"
  }, {
    path: "/admin/customer-service/nominatif",
    component: _3f9a77a5,
    name: "admin-customer-service-nominatif"
  }, {
    path: "/admin/customer-service/registrasi",
    component: _28becaed,
    name: "admin-customer-service-registrasi"
  }, {
    path: "/admin/customer-service/rekening-koran",
    component: _5d7be1a1,
    name: "admin-customer-service-rekening-koran"
  }, {
    path: "/admin/customer-service/rekening-vendor",
    component: _43c2cbb8,
    name: "admin-customer-service-rekening-vendor"
  }, {
    path: "/admin/customer-service/rekening-wali",
    component: _045c9292,
    name: "admin-customer-service-rekening-wali"
  }, {
    path: "/admin/customer-service/riwayat-transfer",
    component: _66043c42,
    name: "admin-customer-service-riwayat-transfer"
  }, {
    path: "/admin/customer-service/tagihan",
    component: _0403aeca,
    name: "admin-customer-service-tagihan"
  }, {
    path: "/admin/customer-service/tagihan-spp",
    component: _6f892a30,
    name: "admin-customer-service-tagihan-spp"
  }, {
    path: "/admin/customer-service/transaksi",
    component: _697dbc8c,
    name: "admin-customer-service-transaksi"
  }, {
    path: "/admin/customer-service/wali",
    component: _9a47bc8e,
    name: "admin-customer-service-wali"
  }, {
    path: "/admin/lms/absensi",
    component: _21034dfd,
    name: "admin-lms-absensi"
  }, {
    path: "/admin/lms/mata-pelajaran",
    component: _4c5dbb5c,
    name: "admin-lms-mata-pelajaran"
  }, {
    path: "/admin/lms/nilai",
    component: _7c25ee05,
    name: "admin-lms-nilai"
  }, {
    path: "/admin/lms/pengajuan",
    component: _38512df7,
    name: "admin-lms-pengajuan"
  }, {
    path: "/admin/lms/raport",
    component: _38fa343a,
    name: "admin-lms-raport"
  }, {
    path: "/admin/master/bank",
    component: _0be5bf52,
    name: "admin-master-bank"
  }, {
    path: "/admin/master/bcn-bank",
    component: _f92d915c,
    name: "admin-master-bcn-bank"
  }, {
    path: "/admin/master/bcn-bank-institution",
    component: _2a994a7d,
    name: "admin-master-bcn-bank-institution"
  }, {
    path: "/admin/master/document-type",
    component: _54fb562c,
    name: "admin-master-document-type"
  }, {
    path: "/admin/master/jenis-kas",
    component: _6ebd6466,
    name: "admin-master-jenis-kas"
  }, {
    path: "/admin/master/jenis-pinjaman",
    component: _60e0f418,
    name: "admin-master-jenis-pinjaman"
  }, {
    path: "/admin/master/jenis-rekening",
    component: _7fee6a32,
    name: "admin-master-jenis-rekening"
  }, {
    path: "/admin/master/jenis-simpanan",
    component: _455ad279,
    name: "admin-master-jenis-simpanan"
  }, {
    path: "/admin/master/jenjang-pendidikan",
    component: _ba64c316,
    name: "admin-master-jenjang-pendidikan"
  }, {
    path: "/admin/master/lembaga",
    component: _cf012526,
    name: "admin-master-lembaga"
  }, {
    path: "/admin/master/lembaga-booking",
    component: _1146300e,
    name: "admin-master-lembaga-booking"
  }, {
    path: "/admin/master/news",
    component: _48bbb329,
    name: "admin-master-news"
  }, {
    path: "/admin/master/news-category",
    component: _ac37dd90,
    name: "admin-master-news-category"
  }, {
    path: "/admin/master/produk",
    component: _41aca543,
    name: "admin-master-produk"
  }, {
    path: "/admin/master/produk-vendor",
    component: _3d051d68,
    name: "admin-master-produk-vendor"
  }, {
    path: "/admin/master/setting-institution",
    component: _9f74b68a,
    name: "admin-master-setting-institution"
  }, {
    path: "/admin/master/tahun-ajaran",
    component: _5a268556,
    name: "admin-master-tahun-ajaran"
  }, {
    path: "/admin/master/transaction-type",
    component: _4374051f,
    name: "admin-master-transaction-type"
  }, {
    path: "/admin/master/vendor",
    component: _05a6a6c4,
    name: "admin-master-vendor"
  }, {
    path: "/admin/pengaturan/activity-logs",
    component: _c74e1c94,
    name: "admin-pengaturan-activity-logs"
  }, {
    path: "/admin/pengaturan/management-user",
    component: _190b7d9e,
    name: "admin-pengaturan-management-user"
  }, {
    path: "/admin/pengaturan/management-user-vendor",
    component: _2a638ea6,
    name: "admin-pengaturan-management-user-vendor"
  }, {
    path: "/admin/pengaturan/permission",
    component: _e3458888,
    name: "admin-pengaturan-permission"
  }, {
    path: "/admin/pengaturan/role",
    component: _ed05b1ba,
    name: "admin-pengaturan-role"
  }, {
    path: "/admin/pengaturan/role-has-permission",
    component: _d24770bc,
    name: "admin-pengaturan-role-has-permission"
  }, {
    path: "/admin/pengaturan/seo",
    component: _7f60e434,
    name: "admin-pengaturan-seo"
  }, {
    path: "/admin/pengaturan/setting-data-fixed",
    component: _00f0285b,
    name: "admin-pengaturan-setting-data-fixed"
  }, {
    path: "/admin/pengaturan/setting-web-app",
    component: _5f6004b4,
    name: "admin-pengaturan-setting-web-app"
  }, {
    path: "/admin/profile/change-password",
    component: _2cc69878,
    name: "admin-profile-change-password"
  }, {
    path: "/admin/rekonsiliasi/invoice",
    component: _b10a2d10,
    name: "admin-rekonsiliasi-invoice"
  }, {
    path: "/admin/rekonsiliasi/transaksi",
    component: _289fc333,
    name: "admin-rekonsiliasi-transaksi"
  }, {
    path: "/admin/transaksi/monitoring-admin",
    component: _68f9447e,
    name: "admin-transaksi-monitoring-admin"
  }, {
    path: "/admin/transaksi/open-api-payments",
    component: _c30a3b76,
    name: "admin-transaksi-open-api-payments"
  }, {
    path: "/admin/transaksi/penarikan",
    component: _79aff07b,
    name: "admin-transaksi-penarikan"
  }, {
    path: "/admin/transaksi/penarikan-otomatis",
    component: _40202648,
    name: "admin-transaksi-penarikan-otomatis"
  }, {
    path: "/admin/transaksi/setoran-tunai",
    component: _110966fc,
    name: "admin-transaksi-setoran-tunai"
  }, {
    path: "/host/flip/accept",
    component: _ca0da926,
    name: "host-flip-accept"
  }, {
    path: "/host/flip/transfer",
    component: _0b554590,
    name: "host-flip-transfer"
  }, {
    path: "/admin/akademik/kenaikan-kelas/histories",
    component: _f04f7398,
    name: "admin-akademik-kenaikan-kelas-histories"
  }, {
    path: "/admin/core/akun-keuangan/create",
    component: _22a6a10b,
    name: "admin-core-akun-keuangan-create"
  }, {
    path: "/admin/core/jurnal-umum/create",
    component: _45c2d654,
    name: "admin-core-jurnal-umum-create"
  }, {
    path: "/admin/customer-service/blast-wa/template",
    component: _01ab5c2e,
    name: "admin-customer-service-blast-wa-template"
  }, {
    path: "/admin/customer-service/candidate/create",
    component: _18d34c12,
    name: "admin-customer-service-candidate-create"
  }, {
    path: "/admin/customer-service/candidate/export",
    component: _a31c9ea2,
    name: "admin-customer-service-candidate-export"
  }, {
    path: "/admin/customer-service/candidate/qr",
    component: _126953c8,
    name: "admin-customer-service-candidate-qr"
  }, {
    path: "/admin/customer-service/candidate/rekening",
    component: _198df03f,
    name: "admin-customer-service-candidate-rekening"
  }, {
    path: "/admin/customer-service/candidate/upload",
    component: _d9068708,
    name: "admin-customer-service-candidate-upload"
  }, {
    path: "/admin/customer-service/nasabah/create",
    component: _5359a2f2,
    name: "admin-customer-service-nasabah-create"
  }, {
    path: "/admin/customer-service/nasabah/export",
    component: _0e34f9aa,
    name: "admin-customer-service-nasabah-export"
  }, {
    path: "/admin/customer-service/nasabah/qr",
    component: _0a785497,
    name: "admin-customer-service-nasabah-qr"
  }, {
    path: "/admin/customer-service/nasabah/rekening",
    component: _b6bbe38c,
    name: "admin-customer-service-nasabah-rekening"
  }, {
    path: "/admin/customer-service/nasabah/upload",
    component: _197ff512,
    name: "admin-customer-service-nasabah-upload"
  }, {
    path: "/admin/customer-service/registrasi/create",
    component: _16cedd71,
    name: "admin-customer-service-registrasi-create"
  }, {
    path: "/admin/customer-service/tagihan-spp/unpaid",
    component: _2d7bb412,
    name: "admin-customer-service-tagihan-spp-unpaid"
  }, {
    path: "/admin/customer-service/tagihan/import",
    component: _5d926946,
    name: "admin-customer-service-tagihan-import"
  }, {
    path: "/admin/customer-service/tagihan/unpaid",
    component: _37cf96c6,
    name: "admin-customer-service-tagihan-unpaid"
  }, {
    path: "/admin/customer-service/wali/create",
    component: _5f473fb6,
    name: "admin-customer-service-wali-create"
  }, {
    path: "/admin/customer-service/wali/rekening",
    component: _0f39e86d,
    name: "admin-customer-service-wali-rekening"
  }, {
    path: "/admin/lms/absensi/create",
    component: _271abc61,
    name: "admin-lms-absensi-create"
  }, {
    path: "/admin/lms/absensi/riwayat",
    component: _22619d0e,
    name: "admin-lms-absensi-riwayat"
  }, {
    path: "/admin/lms/mata-pelajaran/create",
    component: _670dfae2,
    name: "admin-lms-mata-pelajaran-create"
  }, {
    path: "/admin/lms/nilai/create",
    component: _304c1d59,
    name: "admin-lms-nilai-create"
  }, {
    path: "/admin/lms/pengajuan/riwayat",
    component: _5ebb111a,
    name: "admin-lms-pengajuan-riwayat"
  }, {
    path: "/admin/lms/raport/create",
    component: _0e009dc4,
    name: "admin-lms-raport-create"
  }, {
    path: "/admin/master/bank/create",
    component: _cef314a8,
    name: "admin-master-bank-create"
  }, {
    path: "/admin/master/bcn-bank-institution/create",
    component: _50444fe1,
    name: "admin-master-bcn-bank-institution-create"
  }, {
    path: "/admin/master/bcn-bank/create",
    component: _1171fdac,
    name: "admin-master-bcn-bank-create"
  }, {
    path: "/admin/master/document-type/create",
    component: _7223ba12,
    name: "admin-master-document-type-create"
  }, {
    path: "/admin/master/jenis-kas/create",
    component: _733cb691,
    name: "admin-master-jenis-kas-create"
  }, {
    path: "/admin/master/jenis-pinjaman/create",
    component: _4a15834a,
    name: "admin-master-jenis-pinjaman-create"
  }, {
    path: "/admin/master/jenis-rekening/create",
    component: _68c4dcb7,
    name: "admin-master-jenis-rekening-create"
  }, {
    path: "/admin/master/jenis-simpanan/create",
    component: _e4987136,
    name: "admin-master-jenis-simpanan-create"
  }, {
    path: "/admin/master/jenjang-pendidikan/create",
    component: _42cb0a2e,
    name: "admin-master-jenjang-pendidikan-create"
  }, {
    path: "/admin/master/lembaga/bcn-code",
    component: _d258b2b6,
    name: "admin-master-lembaga-bcn-code"
  }, {
    path: "/admin/master/lembaga/create",
    component: _c1baea1e,
    name: "admin-master-lembaga-create"
  }, {
    path: "/admin/master/lembaga/scan-qr-wa",
    component: _315f411b,
    name: "admin-master-lembaga-scan-qr-wa"
  }, {
    path: "/admin/master/news-category/create",
    component: _8b5b3ef4,
    name: "admin-master-news-category-create"
  }, {
    path: "/admin/master/news/create",
    component: _13220696,
    name: "admin-master-news-create"
  }, {
    path: "/admin/master/produk-vendor/create",
    component: _e95a4b54,
    name: "admin-master-produk-vendor-create"
  }, {
    path: "/admin/master/produk/create",
    component: _1b9c4ddb,
    name: "admin-master-produk-create"
  }, {
    path: "/admin/master/tahun-ajaran/create",
    component: _125e7028,
    name: "admin-master-tahun-ajaran-create"
  }, {
    path: "/admin/master/transaction-type/create",
    component: _52c0e97f,
    name: "admin-master-transaction-type-create"
  }, {
    path: "/admin/master/vendor/create",
    component: _5fc59c40,
    name: "admin-master-vendor-create"
  }, {
    path: "/admin/pengaturan/management-user-vendor/create",
    component: _d2a5b09e,
    name: "admin-pengaturan-management-user-vendor-create"
  }, {
    path: "/admin/pengaturan/management-user/create",
    component: _301880e0,
    name: "admin-pengaturan-management-user-create"
  }, {
    path: "/admin/pengaturan/permission/create",
    component: _64fe8682,
    name: "admin-pengaturan-permission-create"
  }, {
    path: "/admin/pengaturan/ppob/product",
    component: _ce42a1c0,
    name: "admin-pengaturan-ppob-product"
  }, {
    path: "/admin/pengaturan/ppob/product-detail",
    component: _596cacb4,
    name: "admin-pengaturan-ppob-product-detail"
  }, {
    path: "/admin/pengaturan/ppob/product-type",
    component: _7c8a565d,
    name: "admin-pengaturan-ppob-product-type"
  }, {
    path: "/admin/pengaturan/role/create",
    component: _6447f00a,
    name: "admin-pengaturan-role-create"
  }, {
    path: "/admin/pengaturan/seo/create",
    component: _71567998,
    name: "admin-pengaturan-seo-create"
  }, {
    path: "/admin/pengaturan/setting-data-fixed/create",
    component: _44c92dc3,
    name: "admin-pengaturan-setting-data-fixed-create"
  }, {
    path: "/admin/pengaturan/setting-web-app/create",
    component: _975646ec,
    name: "admin-pengaturan-setting-web-app-create"
  }, {
    path: "/admin/transaksi/penarikan-otomatis/create",
    component: _28ce2514,
    name: "admin-transaksi-penarikan-otomatis-create"
  }, {
    path: "/admin/transaksi/penarikan/create",
    component: _37fb2cba,
    name: "admin-transaksi-penarikan-create"
  }, {
    path: "/admin/transaksi/setoran-tunai/create",
    component: _37d7c342,
    name: "admin-transaksi-setoran-tunai-create"
  }, {
    path: "/admin/customer-service/blast-wa/template/create",
    component: _5b747450,
    name: "admin-customer-service-blast-wa-template-create"
  }, {
    path: "/admin/pengaturan/ppob/product-detail/create",
    component: _084596ec,
    name: "admin-pengaturan-ppob-product-detail-create"
  }, {
    path: "/admin/pengaturan/ppob/product-type/create",
    component: _3c74c001,
    name: "admin-pengaturan-ppob-product-type-create"
  }, {
    path: "/admin/pengaturan/ppob/product/create",
    component: _aaa900c4,
    name: "admin-pengaturan-ppob-product-create"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/admin/customer-service/blast-wa/template/:id?",
    component: _1f1e9216,
    name: "admin-customer-service-blast-wa-template-id"
  }, {
    path: "/admin/master/produk/custom-nominal/:id?",
    component: _29815eec,
    name: "admin-master-produk-custom-nominal-id"
  }, {
    path: "/admin/master/vendor/rekening/:id",
    component: _c2b7d3da,
    name: "admin-master-vendor-rekening-id"
  }, {
    path: "/admin/master/vendor/user/:id?",
    component: _5bffbe5a,
    name: "admin-master-vendor-user-id"
  }, {
    path: "/admin/pengaturan/ppob/product-detail/:id",
    component: _09e64c1c,
    name: "admin-pengaturan-ppob-product-detail-id"
  }, {
    path: "/admin/pengaturan/ppob/product-type/:id",
    component: _5c844c05,
    name: "admin-pengaturan-ppob-product-type-id"
  }, {
    path: "/admin/pengaturan/ppob/product/:id",
    component: _548df988,
    name: "admin-pengaturan-ppob-product-id"
  }, {
    path: "/admin/master/produk/custom-nominal/:product_id?/create",
    component: _28226c81,
    name: "admin-master-produk-custom-nominal-product_id-create"
  }, {
    path: "/admin/master/vendor/user/:vendor_id?/create",
    component: _004d4f90,
    name: "admin-master-vendor-user-vendor_id-create"
  }, {
    path: "/admin/core/akun-keuangan/:id?",
    component: _73f3173b,
    name: "admin-core-akun-keuangan-id"
  }, {
    path: "/admin/customer-service/candidate/:id?",
    component: _1debe5cf,
    name: "admin-customer-service-candidate-id"
  }, {
    path: "/admin/customer-service/nasabah/:id?",
    component: _7fdeb6b4,
    name: "admin-customer-service-nasabah-id"
  }, {
    path: "/admin/customer-service/wali/:id?",
    component: _70493e61,
    name: "admin-customer-service-wali-id"
  }, {
    path: "/admin/lms/absensi/:id",
    component: _c7d2a8b6,
    name: "admin-lms-absensi-id"
  }, {
    path: "/admin/lms/mata-pelajaran/:id?",
    component: _d0ca3678,
    name: "admin-lms-mata-pelajaran-id"
  }, {
    path: "/admin/lms/nilai/:id",
    component: _01f1adad,
    name: "admin-lms-nilai-id"
  }, {
    path: "/admin/lms/raport/:id",
    component: _bfc805bc,
    name: "admin-lms-raport-id"
  }, {
    path: "/admin/master/bank/:id",
    component: _33c1238c,
    name: "admin-master-bank-id"
  }, {
    path: "/admin/master/bcn-bank-institution/:id?",
    component: _17fc6fb6,
    name: "admin-master-bcn-bank-institution-id"
  }, {
    path: "/admin/master/bcn-bank/:id?",
    component: _4fbe338c,
    name: "admin-master-bcn-bank-id"
  }, {
    path: "/admin/master/document-type/:id?",
    component: _fcfe18d8,
    name: "admin-master-document-type-id"
  }, {
    path: "/admin/master/jenis-kas/:id?",
    component: _43d25f75,
    name: "admin-master-jenis-kas-id"
  }, {
    path: "/admin/master/jenis-pinjaman/:id?",
    component: _416e755c,
    name: "admin-master-jenis-pinjaman-id"
  }, {
    path: "/admin/master/jenis-rekening/:id?",
    component: _8d6b49e2,
    name: "admin-master-jenis-rekening-id"
  }, {
    path: "/admin/master/jenis-simpanan/:id?",
    component: _303d1f21,
    name: "admin-master-jenis-simpanan-id"
  }, {
    path: "/admin/master/jenjang-pendidikan/:id?",
    component: _72aaba1d,
    name: "admin-master-jenjang-pendidikan-id"
  }, {
    path: "/admin/master/lembaga/:id",
    component: _15f3e715,
    name: "admin-master-lembaga-id"
  }, {
    path: "/admin/master/news-category/:id",
    component: _733501a0,
    name: "admin-master-news-category-id"
  }, {
    path: "/admin/master/news/:id",
    component: _6283285e,
    name: "admin-master-news-id"
  }, {
    path: "/admin/master/produk-vendor/:id",
    component: _fae94c60,
    name: "admin-master-produk-vendor-id"
  }, {
    path: "/admin/master/produk/:id",
    component: _d8cdc72a,
    name: "admin-master-produk-id"
  }, {
    path: "/admin/master/setting-institution/:id?",
    component: _48db99e3,
    name: "admin-master-setting-institution-id"
  }, {
    path: "/admin/master/tahun-ajaran/:id?",
    component: _6b21e53e,
    name: "admin-master-tahun-ajaran-id"
  }, {
    path: "/admin/master/transaction-type/:id?",
    component: _642ec347,
    name: "admin-master-transaction-type-id"
  }, {
    path: "/admin/master/vendor/:id",
    component: _0e993e86,
    name: "admin-master-vendor-id"
  }, {
    path: "/admin/pengaturan/activity-logs/:id?",
    component: _64782cc4,
    name: "admin-pengaturan-activity-logs-id"
  }, {
    path: "/admin/pengaturan/management-user-vendor/:id?",
    component: _7006fb56,
    name: "admin-pengaturan-management-user-vendor-id"
  }, {
    path: "/admin/pengaturan/management-user/:id?",
    component: _f40f60f4,
    name: "admin-pengaturan-management-user-id"
  }, {
    path: "/admin/pengaturan/permission/:id",
    component: _1b8205b8,
    name: "admin-pengaturan-permission-id"
  }, {
    path: "/admin/pengaturan/role-has-permission/:id",
    component: _26bbca8a,
    name: "admin-pengaturan-role-has-permission-id"
  }, {
    path: "/admin/pengaturan/role/:id",
    component: _a13ed36a,
    name: "admin-pengaturan-role-id"
  }, {
    path: "/admin/pengaturan/seo/:id",
    component: _73d85c64,
    name: "admin-pengaturan-seo-id"
  }, {
    path: "/admin/pengaturan/setting-data-fixed/:id?",
    component: _6b928583,
    name: "admin-pengaturan-setting-data-fixed-id"
  }, {
    path: "/admin/pengaturan/setting-web-app/:id?",
    component: _24cfa41c,
    name: "admin-pengaturan-setting-web-app-id"
  }, {
    path: "/page/cek-status-booking/:id?",
    component: _df21aa9a,
    name: "page-cek-status-booking-id"
  }, {
    path: "/auth/:registerBak?",
    component: _93637a92,
    name: "auth-registerBak"
  }, {
    path: "/loan/:id",
    component: _07acf548,
    name: "loan-id"
  }, {
    path: "/login-history/:id?",
    component: _a4ccfd3e,
    name: "login-history-id"
  }, {
    path: "/pay/:session_id?",
    component: _f5b3a5bc,
    name: "pay-session_id"
  }, {
    path: "/loan/:id/pay",
    component: _1c5a7cc4,
    name: "loan-id-pay"
  }, {
    path: "/*",
    component: _2efaf336,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
